var _defs, _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill-rule: evenodd;\n      }\n\n      .st2 {\n        fill: url(#Degradado_sin_nombre_4);\n      }\n\n      .st3 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n\n      .st4 {\n        fill: url(#Degradado_sin_nombre_3);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_4",
    "data-name": "Degradado sin nombre 4",
    cx: -0.1,
    cy: 800.1,
    fx: -0.1,
    fy: 800.1,
    r: 1.1,
    gradientTransform: "translate(420393.8 290579.3) rotate(-55.4) scale(638 -638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c62f94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a3ac8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    cx: -0.2,
    cy: 800.1,
    fx: -0.2,
    fy: 800.1,
    r: 1.1,
    gradientTransform: "translate(410368.1 190778.6) rotate(-65.1) scale(564.9 -564.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e8b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fb8a2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e2425c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2425c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_3",
    "data-name": "Degradado sin nombre 3",
    cx: -0.1,
    cy: 800.3,
    fx: -0.1,
    fy: 800.3,
    r: 1.1,
    gradientTransform: "translate(23634.4 164774.1) rotate(-8.1) scale(972.3 -208)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#406adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6a45be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a45be",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 0,
    y: 0,
    width: 800,
    height: 800,
    rx: 171.4,
    ry: 171.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 0,
    y: 0,
    width: 800,
    height: 800,
    rx: 171.4,
    ry: 171.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 0,
    y: 0,
    width: 800,
    height: 800,
    rx: 171.4,
    ry: 171.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M600,242.9c0,23.7-19.2,42.9-42.9,42.9s-42.9-19.2-42.9-42.9,19.2-42.9,42.9-42.9,42.9,19.2,42.9,42.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400,542.9c78.9,0,142.9-64,142.9-142.9s-64-142.9-142.9-142.9-142.9,64-142.9,142.9,64,142.9,142.9,142.9ZM400,485.7c47.3,0,85.7-38.4,85.7-85.7s-38.4-85.7-85.7-85.7-85.7,38.4-85.7,85.7,38.4,85.7,85.7,85.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.3,388.6c0-96,0-144,18.7-180.7,16.4-32.3,42.7-58.5,74.9-74.9,36.7-18.7,84.7-18.7,180.7-18.7h22.9c96,0,144,0,180.7,18.7,32.3,16.4,58.5,42.7,74.9,74.9,18.7,36.7,18.7,84.7,18.7,180.7v22.9c0,96,0,144-18.7,180.7-16.4,32.3-42.7,58.5-74.9,74.9-36.7,18.7-84.7,18.7-180.7,18.7h-22.9c-96,0-144,0-180.7-18.7-32.3-16.4-58.5-42.7-74.9-74.9-18.7-36.7-18.7-84.7-18.7-180.7v-22.9ZM388.6,171.4h22.9c48.9,0,82.2,0,107.9,2.1,25.1,2,37.9,5.8,46.8,10.3,21.5,11,39,28.4,49.9,49.9,4.6,8.9,8.3,21.7,10.3,46.8,2.1,25.7,2.1,59,2.1,107.9v22.9c0,48.9,0,82.2-2.1,107.9-2,25.1-5.8,37.9-10.3,46.8-11,21.5-28.4,39-49.9,49.9-8.9,4.6-21.7,8.3-46.8,10.3-25.7,2.1-59,2.1-107.9,2.1h-22.9c-48.9,0-82.2,0-107.9-2.1-25.1-2-37.9-5.8-46.8-10.3-21.5-11-39-28.4-49.9-49.9-4.6-8.9-8.3-21.7-10.3-46.8-2.1-25.7-2.1-59-2.1-107.9v-22.9c0-48.9,0-82.2,2.1-107.9,2-25.1,5.8-37.9,10.3-46.8,11-21.5,28.4-39,49.9-49.9,8.9-4.6,21.7-8.3,46.8-10.3,25.7-2.1,59-2.1,107.9-2.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c5665fc9c01caa1981245e34b3762492.svg";
export { ForwardRef as ReactComponent };